import React, { useState, useEffect } from 'react'

import { Message, Panel, Row } from 'rsuite'
import scrollToComponent from 'react-scroll-to-component'
import { useForm, Controller } from 'react-hook-form'
import ButtonPanel from '../../ButtonPanel'
import CKEditorFromFull from '../../../components/forms/input/CKEditorFromFull'
import HTMLWidget from '../../HTMLWidget'
import { saveFormProjectBackground } from '../../../redux/actions/subProjectProposal'
import { doneLoading, startLoading } from '../../../utils/loading'
import { sessionGetItemStr } from '../../../utils/sessionHelpers'
import { SUB_PROJECT_ID } from '../../../constants/constants'
import { DEFAULT_ERR_MSG, SAVE_SUCCESS_MSG } from '../../../constants/msgText'
import { setAlertMessage } from '../../../utils/messageUtil'
import CustomAlertMessage from '../../CustomAlertMessage'

export default function ProjectBackgroundWidget(props) {
  const { showCommandButton, isEdit, onChangeIsEdit } = props

  const { register, handleSubmit, errors, control, setValue, clearErrors, getValues } = useForm()

  const [editorData, setEditorData] = useState()
  const [section, setSection] = useState()
  const [isError, setIsError] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [notiMsg, setNotiMsg] = useState()
  const [formSchema, setFormSchema] = useState(props.schema)

  const mode = location.search.substring(1)
  const subProjectId = sessionGetItemStr(SUB_PROJECT_ID)

  useEffect(() => {
    // console.log('formSchema', formSchema)
    var data = formSchema.editorData.value

    formSchema?.mapFileData?.map((item) => {
      // console.log('item :', item)
      // console.log('item.key :', item.key.replace('[[', '').replace(']]', ''))
      if (item.link != null) {
        let link = `<a href="${item.link}" target="_blank"> ${item.key
          .replace('[[', '')
          .replace(']]', '')} </a>`
        data = data.replace(item.key, link)
      }
    })

    // console.log('data : ', data)

    setEditorData(data)
  }, [formSchema])

  const handleSave = async (request) => {
    setIsLoading(true)
    startLoading()
    try {
      let response = await saveFormProjectBackground(subProjectId, request)
      console.log(response)

      if (response) {
        setFormSchema(response)
        setAlertMessage('success', SAVE_SUCCESS_MSG, setNotiMsg)
      } else {
        setAlertMessage('error', DEFAULT_ERR_MSG, setNotiMsg)
      }
    } catch (e) {
      console.log('error', e)
      setAlertMessage('error', e?.response?.data?.errors?.message || DEFAULT_ERR_MSG, setNotiMsg)
    }
    doneLoading()
    setIsLoading(false)

    setTimeout(() => {
      setNotiMsg('')
    }, 2500)
  }

  const onSubmit = (data) => {
    console.log('data', data)

    let values = [
      {
        name: 'editorData',
        value: data.editorData,
      },
    ]

    let request = {
      id: formSchema.id,
      values: values,
    }

    handleSave(request)
  }

  return (
    <Panel
      shaded
      header={formSchema.header}
      collapsible
      defaultExpanded
      ref={(section) => {
        setSection(section)
      }}
      style={{ marginBottom: 20 }}
    >
      {/* <WarningMessage message={formSchema.detail} /> */}

      <div style={{ marginTop: -10 }}>
        {isEdit && showCommandButton ? (
          <>
            {formSchema.description && (
              <Row style={{ marginBottom: 10 }}>
                <CustomAlertMessage contents={formSchema.description} />
              </Row>
            )}

            {formSchema.detail && (
              <Row style={{ marginBottom: 10 }}>
                <Message showIcon type="info" description={formSchema.detail} />
              </Row>
            )}

            <CKEditorFromFull
              key={'formBk'}
              schema={formSchema.editorData}
              register={register}
              Controller={Controller}
              control={control}
              errors={errors}
              setValue={setValue}
              clearErrors={clearErrors}
              getValues={getValues}
            />
          </>
        ) : editorData ? (
          <>
            <div
              style={{ wordWrap: 'break-word' }}
              dangerouslySetInnerHTML={{ __html: editorData }}
            />
          </>
        ) : (
          '-ไม่ได้ระบุ-'
        )}
      </div>

      {formSchema.note && (
        <Message
          showIcon
          type="info"
          style={{ marginTop: 20 }}
          description={<HTMLWidget data={formSchema.note} />}
        />
      )}

      {showCommandButton && !mode && (
        <div className="right">
          <hr />
          {notiMsg && (
            <Message
              closable
              showIcon
              type={notiMsg.type}
              description={notiMsg.msg}
              onClose={() => setNotiMsg('')}
              style={{ marginBottom: 10 }}
              className="left"
            />
          )}
          <ButtonPanel
            isDisabled={isLoading}
            isEdit={isEdit}
            isError={isError}
            buttonText={formSchema.buttonText || formSchema.header}
            onSave={handleSubmit(onSubmit)}
            onCancel={() => {
              setIsError(false)
              onChangeIsEdit(!isEdit)
            }}
            onEdit={() => {
              setIsError(false)
              onChangeIsEdit(!isEdit)
              scrollToComponent(section, { offset: 0, align: 'top', duration: 500 })
            }}
          />
        </div>
      )}
    </Panel>
  )
}
